import { render, staticRenderFns, recyclableRender, components } from "./settings.vue?vue&type=template&id=57211de6&scoped=true&"
var renderjs
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=57211de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57211de6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/settings/settings.vue"
export default component.exports